import Base from 'app/views/base';

import CarrierAccountListItemView from 'app/components/pages/carrier_accounts/carrier_accounts/item';

import tmpl from './list_template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    this.listenTo(this.collection, 'sync filtered remove', this.render);
  },

  beforeRender() {
    this.removeSubviews();
    this.collection.filtered().forEach(ca => {
      this.addSubview(`ca_${ca.id}`, `#ca_${ca.id}`, new CarrierAccountListItemView({
        model: ca,
        collection: this.collection,
      }));
    });
  },

  context() {
    return { carrierAccounts: this.collection.filtered() };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/carrier_accounts/list.js